import { useParams } from "react-router-dom";
import { SingleNotificationDataType } from "../../../../interface/site.interface";
import { useEffect, useState } from "react";
import { NotificationsService } from "../../../../services/notifications.service";
import Spinner from "../../../../components/shared/spinner/Spinner";
import styles from "./SingleNotifications.module.scss";
import AcceptReferalModal from "../../../../components/pages/admin-panels/referal-accounts/accepct-referal-modal/AcceptReferalModal";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

const SingleNotifications = () => {
  const [notification, setNotification] =
    useState<SingleNotificationDataType>();
  const [loading, setLoading] = useState<boolean>(false);
  const [showReferalModal, setShowReferalModal] = useState(false);
const language = useSelector((state: RootState) => state.language.language);

  const params = useParams();
  const id = Number(params.id);

  useEffect(() => {
    setLoading(true);
    NotificationsService.readSingleNotification(id)
      .then((res) => {
        setNotification(res.data);
      })
      .finally(() => setLoading(false));
  }, [id, language]);

  return (
    <div id={styles.single_notification}>
      {loading ? (
        <Spinner />
      ) : (
        <div className={styles.single_notification}>
          {notification ? (
            <div>
              <h3 className={styles.title}>{notification.Title}</h3>
              {notification.Content?.trim() && notification.Content.trim() !== "null" && (
                <p
                  className={styles.content}
                  dangerouslySetInnerHTML={{
                    __html: notification.Content.replace(/\n/g, "<br>"),
                  }}
                />
              )}
              <div className={styles.confirmButtonContainer}>
                {notification?.is_button ? (
                  <button
                    className={styles.confirmButton}
                    onClick={() => {
                      setShowReferalModal(true);
                    }}
                  >
                    Referalı təsdiqlə
                  </button>
                ) : null}
              </div>
            </div>
          ) : (
            <p>Bildiriş tapılmadı</p>
          )}
        </div>
      )}
      <AcceptReferalModal
        showExtraModal={showReferalModal}
        setShowExtraModal={setShowReferalModal}
      />
    </div>
  );
};

export default SingleNotifications;
